'use strict'

const state = {
  enabled: false,
}

const getters = {
  getAdminModeEnabled: (state) => Boolean(state.enabled),
}

const mutations = {
  SET_ADMIN_MODE(state, enabled) {
    state.enabled = Boolean(enabled)
  },
}

const actions = {
  setAdminMode({ commit }, enabled) {
    commit('SET_ADMIN_MODE', enabled)
  },
  toggleAdminMode({ commit, state }) {
    commit('SET_ADMIN_MODE', !state.enabled)
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}


